import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=38cadfae&scoped=true&lang=html&"
import script from "./SearchInput.vue?vue&type=script&lang=js&"
export * from "./SearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cadfae",
  null
  
)

export default component.exports